import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FlamingoHttpService } from '@flamingo/service/flamingo-http.service';
import { FlamingoMessageService } from '@flamingo/service/flamingo-message.service';
import { fuseAnimations } from '@fuse/animations';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { Attachment, AttachmentType, DocumentStatus } from '../../../../../../../../../../core/model/invoice.model';
import { AuctionSellerService } from '../../../../auction-seller.service';
import { locale as english } from './i18n/en';
import { locale as italian } from './i18n/it';

@Component({
  selector: 'app-edit-document-dialog',
  templateUrl: './edit-document-dialog.component.html',
  styleUrls: ['./edit-document.scss'],
  animations: [fuseAnimations],
})
export class EditDocumentDialogComponent implements OnInit {
  @ViewChild('fileInputOtherDoc') fileInputOtherDoc: ElementRef;

  uploadingAttachment = false;

  uuid: string;
  invoiceFiles: Attachment[] = [];
  attachmentForm: UntypedFormGroup;
  AttachmentType = AttachmentType;
  DocumentStatus = DocumentStatus;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EditDocumentDialogModel,
    private _auctionSellerService: AuctionSellerService,
    private _dialogRef: MatDialogRef<EditDocumentDialogComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _httpService: FlamingoHttpService,
    private _messageService: FlamingoMessageService,
    private _translationLoader: FuseTranslationLoaderService,
    private _translateService: TranslateService,
  ) {
    this._translationLoader.loadTranslations(italian, english);
  }

  ngOnInit(): void {
    this.uuid = this.data.invoiceUuid;
    this.invoiceFiles = this.data.attachments;

    this.attachmentForm = this._formBuilder.group({
      attachmentType: [null],
    });
  }

  viewAttachment(uuid: string, attachmentId: number): void {
    this._auctionSellerService.downloadSentInvoiceAttachment(uuid, attachmentId).subscribe(
      res => {
        this._httpService.openInBrowserFromAWSUrl(res);
      },
      err => {
        throw err;
      },
    );
  }

  editAttachment(event: any, attachmentId: number, type: AttachmentType): void {
    this.uploadingAttachment = true;
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append('attachmentFile', file);

    this._auctionSellerService
      .updateSentInvoiceAttachmentFile(formData, this.uuid, attachmentId)
      .subscribe(
        res => {
          const index = this.invoiceFiles.findIndex(f => f.id === res.id);
          if (index !== -1) {
            this.invoiceFiles.splice(index, 1, res);
          }
          this.uploadingAttachment = false;
        },
        () => {
          this.uploadingAttachment = false;
          this._messageService.showMessage(
            this._translateService.instant('INVOICE.SNACKBAR.ATTACHMENT_ERROR') + ': ' + file.name,
          );
        },
      );
  }

  closeDialog(): void {
    this._dialogRef.close(true);
  }
}

export interface EditDocumentDialogModel {
  invoiceUuid: string;
  attachments: Attachment[];
}
